import { useCallback, useMemo } from "react";
import { produce } from "immer";
import { useLazyGetVulnerabilityReferenceNamesQuery } from "../../services/vulnerabilities.api";
import { getSortedVulnerabilityReferences } from "../utils";
// Return type is inferred because RTK query trigger has complex types
// It is much simpler in this case to let TS infer type is
const useReferencesFilter = (filter) => {
    const [triggerGetReferenceNames, { data: references, isFetching }] = useLazyGetVulnerabilityReferenceNamesQuery();
    const getOptionLabel = useCallback((id) => {
        const reference = references === null || references === void 0 ? void 0 : references.references[id];
        if (reference) {
            return `${reference.product} ${reference.version}`;
        }
        else if (filter.ui_selected_name &&
            (filter.reference_id || filter.dependency_id)) {
            // If user clicks on one of CVE badges, they will be redirected to Vulnerabilities table
            // Table will be automatically filtered by that reference (component or dependency)
            // When that happens, references data will not be yet fetched from the backend so
            // we need to substitute label with the one stored in filter state
            return filter.ui_selected_name;
        }
        else {
            return "";
        }
    }, [references, filter]);
    const autocompleteOptions = useMemo(() => {
        return references ? getSortedVulnerabilityReferences(references) : [];
    }, [references]);
    const handleFilterChange = useCallback((value) => {
        return produce(filter, (draft) => {
            const reference = references && value
                ? references.references[value]
                : undefined;
            if (reference) {
                draft.ui_selected_name = `${reference.product} ${reference.version}`;
                if (reference.type === "COMPONENT") {
                    draft.reference_id = value ? value : null;
                    draft.dependency_id = null;
                }
                else {
                    draft.dependency_id = value ? value : null;
                    draft.reference_id = null;
                }
            }
            else {
                draft.ui_selected_name = null;
                draft.reference_id = null;
                draft.dependency_id = null;
            }
        });
    }, [references, filter]);
    return {
        triggerGetReferenceNames,
        autocompleteOptions,
        getOptionLabel,
        handleFilterChange,
        references,
        isFetching,
    };
};
export default useReferencesFilter;
//# sourceMappingURL=useReferencesFilter.js.map